<script lang="ts">
import MainPage from "@/Components/MainPage.vue";
import AppLayout from "@/Layouts/App.vue";
import { EconomicSector, EconomicSectors } from "@/Types";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    components: {
        MainPage,
    },
    layout: AppLayout,
    props: {
        economicSectors: {
            type: Array as PropType<EconomicSectors>,
            required: true,
        },
    },
    computed: {
        decoratedEconomicSectors(): Array<EconomicSector & { isEven: boolean; isOdd: boolean }> {
            return this.economicSectors.map((sector, index) => ({
                ...sector,
                isEven: index % 2 === 0,
                isOdd: index % 2 === 1,
            }));
        },
    },
});
</script>
<template>
    <MainPage :title="$trans('navigation.nav_economic_sectors')" :title-id="'economic-sectors-page'" :gap="true">
        <div class="economic-sectors-list flex flex--v flex--width flex--valign-c flex--gap-40">
            <div v-for="sector in decoratedEconomicSectors" :key="sector.id" class="economic-sectors-list-entry flex flex--width flex--valign-c flex--gap-50">
                <div class="image-circle image-circle--left" :class="{ hidden: sector.isOdd }">
                    <img :src="'imgs/' + sector.name + '.jpg'" class="d-block" />
                </div>

                <div class="economic-sectors-list-entry-content flex--extend flex flex--v flex--valign-s flex--gap-10" :class="{ 'flex--valign-s': sector.isEven, 'flex--valign-e': sector.isOdd }">
                    <span class="economic-sectors-list-entry-text text text--uppercase text--primary-b text--size-22 text--semi-bold" :class="{ 'text--right': sector.isOdd }">
                        {{ $trans("company." + sector.name) }}
                    </span>
                    <span class="economic-sectors-list-entry-text text text--accent-gray-b text--size-20 text--medium" :class="{ 'text--right': sector.isOdd }">
                        {{ $trans("company." + sector.name + "_desc") }}
                    </span>
                </div>

                <div class="image-circle image-circle--right" :class="{ hidden: sector.isEven }">
                    <img :src="'imgs/' + sector.name + '.jpg'" class="d-block" />
                </div>
            </div>
        </div>
    </MainPage>
</template>

<style lang="scss" scoped>
.economic-sectors-list {
    .economic-sectors-list-entry {
        .image-circle {
            width: rem(200);
            min-width: rem(200);
            height: rem(200);
            min-height: rem(200);
            border-radius: 50%;
            overflow: hidden;

            &.hidden {
                display: none;
            }

            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }

        .economic-sectors-list-entry-content {
            .economic-sectors-list-entry-text {
                position: relative;
            }
        }
    }
}

@include media-breakpoint-down(md) {
    .economic-sectors-list {
        .economic-sectors-list-entry {
            .image-circle {
                width: rem(128);
                min-width: rem(128);
                height: rem(128);
                min-height: rem(128);
            }
        }
    }
}
@include media-breakpoint-down(sm) {
    .economic-sectors-list {
        gap: rem(60);
        .economic-sectors-list-entry {
            flex-direction: column;
            gap: rem(25);

            .image-circle {
                width: auto;
                min-width: rem(180);
                height: rem(180);
                min-height: rem(180);
                border-radius: rem(20);

                &.image-circle--right {
                    display: none;
                }
                &.hidden {
                    &.image-circle--left {
                        display: block;
                    }
                }
            }

            .economic-sectors-list-entry-content {
                justify-content: center;
                align-items: center;
                justify-content: center;
                .economic-sectors-list-entry-text {
                    text-align: center;
                }
            }
        }
    }
}
</style>
